var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"b-color outline light--border",class:{ selected: _vm.selected, small: _vm.small },style:(`background-color:${ _vm.color[0] };`)},'component',_vm.$attrs,false),_vm.$listeners),[(_vm.color[1])?_c('span',{style:(`border-color: ${ _vm.color[1] }`)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }